// import React from 'react';
import PropTypes from 'prop-types';

export function createEmptyWebSocketContext() {
  function NamespaceWebSocketProvider({
    children,
  }) {
    return children;
  }

  NamespaceWebSocketProvider.propTypes = {
    children: PropTypes.node.isRequired,
  };

  const useNamespaceWebSocket = () => null;

  return {
    NamespaceWebSocketProvider,
    useNamespaceWebSocket,
  };
}
